import Appsignal from '@appsignal/javascript';
export const appsignal = new Appsignal({
    key: process.env.REACT_APP_APPSIGNAL_PUSH_KEY,
});
